var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-full-report"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("完整报告")]),_c('p',[_vm._v("孩子ID: "+_vm._s(_vm.$route.params.childId))]),_c('p',[_vm._v("孩子完整学习报告页面，开发中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }